import React from 'react'
import RatingContentReportView from "../../views/ver_24.10/ProgramRating/DQRating/DQRatingContentReport.view";

const RatingContentReportMain = () => {
    const programInfo = [
        { title: "Type:", value: "Learning Program" },
        { title: "Total Estimated Learning Time:", value: "8 Hours" },
        { title: "Country:", value: "Singapore" },
        { title: "Audience:", value: "Secondary Students" },
    ];

    const data = {
        programInfo,
    };

    // Actions handling business logic
    const actions = {
    };

    // Configuration options for visual appearance
    const options = {
    };

    return (
        <>
            <RatingContentReportView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default RatingContentReportMain;